import { combineReducers } from 'redux';

import session from 'src/routes/auth/auth.reducer';
import dashboardGeneral from 'src/routes/dashboard/general/general.reducer';

import toast from 'src/components/toast/toastReducer';
import sidebar from 'src/components/sidebar/sidebar.reducer';

import routes from 'src/routes/routes/routes.reducer';

import user from 'src/store/user/user.reducer';
import userInfo from 'src/store/user-info/user-info.reducer';

import usersAndPermissions from 'src/routes/users-and-permissions/users-and-permissions.reducer';

import liveMap from 'src/routes/live/data/map-reducer';

import team from 'src/routes/team/team.reducer';

import lytTeam from 'src/routes/lyt-team-management/lyt-team.reducer';

import featureFlags from 'src/store/feature-flags/feature-flags.reducer';
import transitInsights from 'src/routes/transit-insights/data/transit-insights.reducer';
import tripAnalyzer from 'src/routes/trip-analyzer/data/trip-analyzer.reducer';
import tripTracer from 'src/routes/trip-tracer/data/trip-tracer.reducer';

const rootReducer = combineReducers({
    session,
    dashboardGeneral,
    toast,
    sidebar,
    user,
    userInfo,
    routes,
    usersAndPermissions,
    liveMap,
    team,
    lytTeam,
    featureFlags,
    transitInsights,
    tripAnalyzer,
    tripTracer,
});

export default rootReducer;
